import { Default } from '@crochik/pi-react/context';
import * as Calendar from './Calendar';
import onSubmit from './Submit';
import createLead from './CreateLead';
import * as Appointment from './Appointment';

import { App } from '@crochik/pi-react/application/App';

export default function register() {
    App.bindAction('createLead', createLead);
    App.bindAction('schedule', onSubmit);
    App.bindAction('cancelAppointment', Appointment.cancel);
    App.bindAction('keepAppointment', Appointment.keep);
    App.bindAction('redirect', () => console.log('redirect'));

    Default.actions.set('onClick', Calendar.onClick, 'page.Calendar');
    Default.actions.set('skipAppointment', Calendar.skipAppointment, 'page.Calendar');
}


// WEBPACK FOOTER //
// ./src/app/actions/index.ts